import { Injectable } from "@angular/core";
import { CacheService } from "app/core/services/cache.service";

@Injectable({
  providedIn: "root",
})
export class StorageService {
  public static CURRENT_THEME: string = "CURRENT_THEME";
  public static CURRENT_LANGUAGE: string = "CURRENT_LANGUAGE";
  public static TOKEN: string = "token";

  public static getState(type: string, defaultState: boolean): boolean {
    return CacheService.getCached<boolean>(type, defaultState);
  }

  static set currentTheme(value: string) {
    CacheService.store(StorageService.CURRENT_THEME, value, false);
  }

  static get currentTheme(): string {
    return CacheService.getCached(StorageService.CURRENT_THEME, "");
  }

  static set currentLanguage(language: string) {
    CacheService.store(StorageService.CURRENT_LANGUAGE, language, false);
  }

  static get currentLanguage(): string {
    return CacheService.getCached<string>(StorageService.CURRENT_LANGUAGE, "");
  }
}
